import { render } from "./FormRadioGroup.vue?vue&type=template&id=28273f42"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__